import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle
} from 'react';
import serviceType from '../../../utils/service-type';
import service from '../../../utils/service';
import shipmentApi from '../../../api/shipment';
import sessions from '../../../sessions';
import Form, {Item} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import 'whatwg-fetch';
import './index.scss';

const MarkAsShipped = forwardRef(({data}, ref) => {
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const [shipment,setShipment] = useState([]);
   
    useEffect(() => {
        var test = [];
        const now = new Date();
        if (data?.length > 0) {
            data.map(item => {
                test.push({
                    "orderId": item._id,
                    "orderNo": item.orderNo,
                    "shipmentDate": now,
                    "serviceType": "",
                    "trackingNo": ""
                })
            });
            setShipment(test)
        }
    }, [data])

    const saveOnClick = (e) => {
        e.validationGroup.validate();
        onSubmit(e);
    }

    const onSubmit = async(e) => {
        e.event.preventDefault();
        //console.log("shipmentData",shipment);
        await shipmentApi.markAsShipped(userId, shipment,auth)
        .then((res) => {
            notify("order mark as shipped", "success", 500);
        }).catch(err=>{
            notify("there is something wrong. Try again later", "error", 500);
        }) 
    }

    useImperativeHandle(ref, (e) => ({saveOnClick}));

    return (
       <Form formData={shipment}>
            <Item
                editorType="dxDataGrid"
                editorOptions={{
                dataSource: shipment,
                showBorders:true,
                columns: [
                    {
                        dataField: "orderId",
                        datatype: "string",
                        visible: false
                    },
                    {
                        dataField: "orderNo",
                        datatype: "string",
                        allowEditing: false
                    }, {
                        dataField: "shipmentDate",
                        datatype: "string",
                        dataType:'date',
                    },{
                        dataField: "trackingCompany",
                        datatype: "string",
                        validationRules:[{
                            type: 'required',
                            message: 'tracking company cant be empty'
                        }],
                    },{
                        dataField: "trackingNo",
                        datatype: "string",
                        validationRules:[{
                            type: 'required',
                            message: 'tracking no cant be empty'
                        }],
                    }
                ],
                editing: {
                    mode: 'row',
                    allowUpdating:true,
                }
            }}/>
       </Form>
    );
})
export default MarkAsShipped;